export const FORM_SUBMIT_ERROR = 'form_submit_error';
export const CLEAR_FORM_SUBMIT_ERROR = 'clear_form_submit_error';
export const MAKE_API_CALL = 'make_api_call';

//api actions calls


// WEBPACK FOOTER //
// ./src/actions/types.js